export const FIELD_TYPES = [
  "string",
  "number",
  "date",
  "currency",
  "boolean",
  "enum",
  "object",
] as const;

export type FieldType = (typeof FIELD_TYPES)[number];

export type DocTypeSource = "system_seeded" | "custom";

export interface UesFieldDef {
  name: string;
  label: string;
  description: string;
  required: boolean;
  type: FieldType;
  isList: boolean;
  enumValues: string[] | null;
  fields: UesFieldDef[] | null;
}

export interface DocType {
  id: string;
  key: string;
  displayName: string;
  description: string;
  uesFields: UesFieldDef[];
  schemaVersion: number;
  source: DocTypeSource;
  createdAt: string;
  updatedAt: string;
}
